/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListOrganizationUserSessionIssuersResult,
  ListOrganizationUserSessionIssuersResult$inboundSchema,
} from "../components/listorganizationusersessionissuersresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListOrganizationUserSessionIssuersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Only issuers from one tier: organization-owned (organization) or project-specific (project). Omitted lists both.
 */
export const QueryParamTier = {
  Organization: "organization",
  Project: "project",
} as const;
/**
 * Only issuers from one tier: organization-owned (organization) or project-specific (project). Omitted lists both.
 */
export type QueryParamTier = ClosedEnum<typeof QueryParamTier>;

export type ListOrganizationUserSessionIssuersRequest = {
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Only issuers from one tier: organization-owned (organization) or project-specific (project). Omitted lists both.
   */
  tier?: QueryParamTier | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListOrganizationUserSessionIssuersResponse = {
  result: ListOrganizationUserSessionIssuersResult;
};

/** @internal */
export type ListOrganizationUserSessionIssuersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuersSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationUserSessionIssuersSecurity$Outbound,
    ListOrganizationUserSessionIssuersSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listOrganizationUserSessionIssuersSecurityToJSON(
  listOrganizationUserSessionIssuersSecurity:
    ListOrganizationUserSessionIssuersSecurity,
): string {
  return JSON.stringify(
    ListOrganizationUserSessionIssuersSecurity$outboundSchema.parse(
      listOrganizationUserSessionIssuersSecurity,
    ),
  );
}

/** @internal */
export const QueryParamTier$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamTier
> = z.enum(QueryParamTier);

/** @internal */
export type ListOrganizationUserSessionIssuersRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  tier?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuersRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationUserSessionIssuersRequest$Outbound,
    ListOrganizationUserSessionIssuersRequest
  > = z.pipe(
    z.object({
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      tier: z.optional(QueryParamTier$outboundSchema),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function listOrganizationUserSessionIssuersRequestToJSON(
  listOrganizationUserSessionIssuersRequest:
    ListOrganizationUserSessionIssuersRequest,
): string {
  return JSON.stringify(
    ListOrganizationUserSessionIssuersRequest$outboundSchema.parse(
      listOrganizationUserSessionIssuersRequest,
    ),
  );
}

/** @internal */
export const ListOrganizationUserSessionIssuersResponse$inboundSchema:
  z.ZodMiniType<ListOrganizationUserSessionIssuersResponse, unknown> = z.pipe(
    z.object({
      Result: ListOrganizationUserSessionIssuersResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listOrganizationUserSessionIssuersResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationUserSessionIssuersResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationUserSessionIssuersResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationUserSessionIssuersResponse' from JSON`,
  );
}
